/**
 * @param {string} [slug]
 *
 * @returns {number | undefined}
 */
export function getIdFromSlug(slug) {
  if (slug !== undefined) {
    const match = slug.match(/([0-9]*)(-.*)/);
    if (match) {
      const number = parseInt(match[1]);
      return isNaN(number) ? undefined : number;
    }
  }
}
